module.exports = __webpack_public_path__ + "img/prize-05.cf077035.png";